import { connect } from 'react-redux'
import RAMSDecline from './RAMSDecline'
import { setHeaderBurger, setHeaderSignOut } from '../../store/header/actions'
import { resetSignIn } from '../../store/signIn/actions'

const mapStateToProps = state => ({
  contractor: state.contractor.registeredContractor,
  userName: state.user.userName,
  contractorId: state.loggedInUser.user.id,
  deviceType: state.device.deviceType,
  site: state.sainsburysSites.site,
  sites: state.sainsburysSites.sites,
  employerId: state.loggedInUser.user.employerId,
  signInState: state.signIn
})

const mapDispatchToProps = dispatch => ({
  setHeader: (state) => {
    dispatch(setHeaderBurger(state))
  },
  setSignOutHeader: (state) => {
    dispatch(setHeaderSignOut(state))
  },
  resetSignIn: () => {
    dispatch(resetSignIn())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(RAMSDecline)
